module.exports = __webpack_public_path__ + "static/media/435_Kitchen.40f580d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Kitchen.jpg
// module id = 562
// module chunks = 0